export const 
      INTERACTIONS_LIST_PREPARE = 'INTERACTIONS_LIST_PREPARE',
      INTERACTIONS_LIST_REQUEST = 'INTERACTIONS_LIST_REQUEST',

      DELETE_INTERACTION_PREPARE = 'DELETE_INTERACTION_PREPARE',
      DELETE_INTERACTION_REQUEST = 'DELETE_INTERACTION_REQUEST',

      TRIGGER_EVENT_PREPARE = 'TRIGGER_EVENT_PREPARE',
      TRIGGER_EVENT_REQUEST = 'TRIGGER_EVENT_REQUEST',
      TRIGGER_EVENTS_REQUEST = 'TRIGGER_EVENTS_REQUEST',
    
      ARCHIVE_INTERACTION_PREPARE = 'ARCHIVE_INTERACTION_PREPARE',
      ARCHIVE_INTERACTION_REQUEST = 'ARCHIVE_INTERACTION_REQUEST',
      UNARCHIVE_INTERACTION_PREPARE = 'UNARCHIVE_INTERACTION_PREPARE',
      UNARCHIVE_INTERACTION_REQUEST = 'UNARCHIVE_INTERACTION_REQUEST',
    
      ASSIGN_INTERACTION_PREPARE = 'ASSIGN_INTERACTION_PREPARE',
      ASSIGN_INTERACTION_REQUEST = 'ASSIGN_INTERACTION_REQUEST',
      UNASSIGN_INTERACTION_PREPARE = 'UNASSIGN_INTERACTION_PREPARE',
      UNASSIGN_INTERACTION_REQUEST = 'UNASSIGN_INTERACTION_REQUEST',

      INTERACTION_INFO_PREPARE = 'INTERACTION_INFO_PREPARE',
      INTERACTION_INFO_REQUEST = 'INTERACTION_INFO_REQUEST',

      NOTICE_INTERACTION = 'NOTICE_INTERACTION'